import { render, staticRenderFns } from "./waitAccreditation.vue?vue&type=template&id=0ee6d5e0"
import script from "./waitAccreditation.vue?vue&type=script&lang=js"
export * from "./waitAccreditation.vue?vue&type=script&lang=js"
import style0 from "./waitAccreditation.vue?vue&type=style&index=0&id=0ee6d5e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports